import React, { ReactElement } from 'react';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@material-ui/core';

type CheckboxInputProps<T extends FieldValues> = {
  name: Path<T>;
  useFormReturn: UseFormReturn<T>;
  label: string;
  fullWidth?: boolean;
  disabled?: boolean;
  helperText?: string;
  required?: boolean;
  validate?: any;
  readonly?: boolean;
};

export const CheckboxInput = <T extends FieldValues>({
  name,
  useFormReturn,
  readonly,
  required,
  validate,
  label,
  fullWidth,
  disabled,
  helperText,
}: CheckboxInputProps<T>): ReactElement => {
  return (
    <Controller
      name={name}
      control={useFormReturn.control}
      rules={{
        required: !readonly
          ? {
              value: required,
              message: 'Dieses Feld ist ein Pflichtfeld.',
            }
          : undefined,
        validate: readonly ? undefined : validate,
      }}
      render={({ field, fieldState }) => {
        return (
          <FormControlLabel
            control={<Checkbox {...field} checked={field.value} />}
            label={label}
            checked={field.value}
            {...field}
          />
        );
      }}
    />
  );
};
